import DisbursementTab from "@/components/DisbursementTab.tsx";
import MediaDocumentsCollectionForCase from "@/components/Documents/MediaDocumentsCollectionForCase.tsx";
import CaseTasksForTab from "@/components/Forms/CaseTasksForTab.tsx";
import CaseSubformDetails from "@/components/Forms/SubForms/CaseSubformDetails.tsx";
import LiabilityTab from "@/components/LiabilityTab.tsx";
import LoanTab from "@/components/LoanTab.tsx";
import NegotiationTab from "@/components/NegotiationTab.tsx";
import ProvidersTab from "@/components/ProvidersTab.tsx";
import CaseTasksGroupByDate from "@/components/Table/CaseTasksGroupByDate.tsx";
import { CustomTabPanel } from "@/components/Tabs/CustomTabPanel.tsx";
import TabWithBadge from "@/components/Tabs/TabWithBadge.tsx";
import UmUimTab from "@/components/UmUimTab.tsx";
import type { CaseData } from "@/queries/useFetchCase.ts";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import * as React from "react";
import DockGen from "../Table/DockGen";

type Props = {
    foundCaseId: string;
    caseIdUUID: string;
    caseData: CaseData;
};

const CaseTabs = ({ foundCaseId, caseIdUUID, caseData }: Props) => {
    const [value, setValue] = React.useState(0);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    TabIndicatorProps={{
                        sx: { display: "none" },
                        style: {
                            backgroundColor: "#D97D54",
                        },
                    }}
                    value={value}
                    onChange={handleChange}
                    aria-label="Case Tabs"
                    sx={{
                        "& .MuiTabs-flexContainer": {
                            flexWrap: "wrap",
                        },
                    }}
                    centered
                >
                    <TabWithBadge caseUUID={caseIdUUID} label="Case Details" index={0} />
                    <TabWithBadge
                        caseUUID={caseIdUUID}
                        label="Liability"
                        limitToCategory="Liability"
                        index={1}
                    />
                    <TabWithBadge
                        caseUUID={caseIdUUID}
                        label="UM/UIM"
                        limitToCategory="UM/UIM"
                        index={2}
                    />
                    <TabWithBadge
                        caseUUID={caseIdUUID}
                        label="Providers"
                        limitToCategory="Providers"
                        index={3}
                    />
                    <TabWithBadge
                        caseUUID={caseIdUUID}
                        label="Loan"
                        limitToCategory="Loan"
                        index={4}
                    />
                    <TabWithBadge
                        caseUUID={caseIdUUID}
                        label="Negotiation"
                        limitToCategory="Negotiation"
                        index={5}
                    />
                    <TabWithBadge
                        caseUUID={caseIdUUID}
                        label="Disbursements"
                        limitToCategory="Disbursements"
                        index={6}
                    />
                    <TabWithBadge
                        caseUUID={caseIdUUID}
                        label="General Media"
                        limitToCategory="General Media"
                        index={7}
                    />
                    <TabWithBadge
                        caseUUID={caseIdUUID}
                        label="Tasks"
                        limitToCategory="Tasks"
                        index={8}
                    />
                    <TabWithBadge
                        caseUUID={caseIdUUID}
                        label="Doc Gen"
                        limitToCategory="Doc Gen"
                        index={9}
                    />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <CaseTasksForTab caseUUID={caseIdUUID} caseStatus="Case Details" />
                {caseIdUUID && (
                    <CaseSubformDetails caseIdUUID={caseIdUUID} foundCaseId={foundCaseId} />
                )}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <CaseTasksForTab caseUUID={caseIdUUID} caseStatus="Liability" />
                {foundCaseId && <LiabilityTab caseIdUUID={caseIdUUID} />}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                <CaseTasksForTab caseUUID={caseIdUUID} caseStatus="UM/UIM" />
                {foundCaseId && caseData && (
                    <UmUimTab
                        caseIdUUID={caseIdUUID}
                        foundCaseId={foundCaseId}
                        caseData={caseData}
                    />
                )}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
                <CaseTasksForTab caseUUID={caseIdUUID} caseStatus="Providers" />
                {foundCaseId && <ProvidersTab caseIdUUID={caseIdUUID} />}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4}>
                <CaseTasksForTab caseUUID={caseIdUUID} caseStatus="Loan" />
                {foundCaseId && <LoanTab caseIdUUID={caseIdUUID} />}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={5}>
                <CaseTasksForTab caseUUID={caseIdUUID} caseStatus="Negotiation" />
                {foundCaseId && (
                    <NegotiationTab caseIdUUID={caseIdUUID} foundCaseId={foundCaseId} />
                )}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={6}>
                <CaseTasksForTab caseUUID={caseIdUUID} caseStatus="Disbursements" />
                {foundCaseId && <DisbursementTab caseIdUUID={caseIdUUID} />}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={7}>
                <CaseTasksForTab caseUUID={caseIdUUID} caseStatus="General Media" />
                {foundCaseId && <MediaDocumentsCollectionForCase caseIdUUID={caseIdUUID} />}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={8}>
                <CaseTasksForTab caseUUID={caseIdUUID} caseStatus="Tasks" />
                <CaseTasksGroupByDate foundCaseId={foundCaseId} caseIdUUID={caseIdUUID} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={9}>
                <CaseTasksForTab caseUUID={caseIdUUID} caseStatus="Doc Gen" />
                <DockGen foundCaseId={foundCaseId} caseIdUUID={caseIdUUID} />
            </CustomTabPanel>
        </Box>
    );
};

export default CaseTabs;
